import { JobApplication } from '../../../services/JobApplication/types'

/** "Analista de Marketing — RP nº 12"; just the name for applications from before the RPs. */
export const vacancyLabel = (application: Pick<JobApplication, 'job_position' | 'job_requisition'>) =>
  application.job_requisition
    ? `${application.job_position} — RP nº ${application.job_requisition.number}`
    : application.job_position
